module.exports = __webpack_public_path__ + "img/signupIllustration.550b7324.svg";